// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string, number, boolean } from "@altostra/type-validations/lib/primitives";
import { isEngagementGeofencesDataResult } from "@dashboardApi/apis/engagementGeofencesData";

export const isEngagementLocationSetDataResult = objectOf({
  location_set: objectOf({
    id: string,
    name: string,
    tag_names: arrayOf(string),
    geofence_count: number,
    last_edited: number,
    archived: boolean,
    changelog_count: number,
  }),
  geofences: isEngagementGeofencesDataResult,
  all_tags: arrayOf(string),
});
